import React from 'react';
import { styled } from '@linaria/react';

import { Logout } from '../../ui/icon';

const LogoutBtn = styled.button`
  display: block;
  outline: none;
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
  position: absolute;
  right: 0;
  top: 50%;
  width: 43px;
  height: 43px;
  margin-top: -21.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0 var(--bb-field-border-radius) var(--bb-field-border-radius) 0;

  &:hover {
    cursor: pointer;
  }
`;

const LogoutButton = props => {
  return (
    <LogoutBtn {...props}>
      <Logout />
    </LogoutBtn>
  );
};

export default LogoutButton;
